import { Flex } from 'app/components/common/Flex';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from 'app/components/common/SettingsContentPanel';
import { Button, Checkbox, Select } from 'antd';
import ConditionalRender from 'app/common/components/ConditionalRender';
import { ConvectionSource } from 'app/model/SOL49';
import AppContext from 'app/common/context/AppContext';

export const DEFAULT_MAP_SETTINGS: MapSettings = {
    showConvection: true,
    showConvectionLegend: false,
    showConvectionTvs: false,
    showConvectionLabel: false,
    convectionRiskLevel: 1,
    hideConvectionWithNoImpact: false,
};

export interface MapSettings {
    showConvection: boolean;
    showConvectionLegend: boolean;
    showConvectionTvs: boolean;
    showConvectionLabel: boolean;
    convectionRiskLevel: number;
    hideConvectionWithNoImpact: boolean;
}

export class MapSettingsTitle extends PureComponent {
    render() {
        return (
            <Flex direction="vertical">
                <div style={{ fontWeight: 'bold' }}>MAP SETTINGS</div>
            </Flex>
        );
    }
}

export class MapSettingsContent extends SettingsContentPanel<MapSettings> {
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '20em', padding: '1em' }}>
                <Flex className="label">
                    <Checkbox
                        checked={this.state.showConvection}
                        onChange={value => this.setState({ showConvection: value.target.checked })}>
                        Show Convection
                    </Checkbox>
                </Flex>
                <Flex className="label">
                    <Checkbox
                        disabled={!this.state.showConvection}
                        checked={this.state.showConvectionLegend}
                        onChange={value => this.setState({ showConvectionLegend: value.target.checked })}>
                        Show Legend
                    </Checkbox>
                </Flex>
                <ConditionalRender
                    condition={
                        AppContext.getConvectionSource() === ConvectionSource.DWD ||
                        AppContext.getConvectionSource() === ConvectionSource.DWD_ICONV
                    }>
                    <Flex className="label">
                        <Checkbox
                            disabled={!this.state.showConvection}
                            checked={this.state.showConvectionTvs}
                            onChange={value => this.setState({ showConvectionTvs: value.target.checked })}>
                            Show TFVs
                        </Checkbox>
                    </Flex>
                </ConditionalRender>
                <ConditionalRender
                    condition={
                        AppContext.getConvectionSource() === ConvectionSource.METSAFE || this.state.showConvectionTvs
                    }>
                    <Flex className="label">
                        <Checkbox
                            disabled={!this.state.showConvection}
                            checked={this.state.showConvectionLabel}
                            onChange={value => this.setState({ showConvectionLabel: value.target.checked })}>
                            Show Labels
                        </Checkbox>
                    </Flex>
                </ConditionalRender>
                <Flex className="label">
                    <Flex style={{ alignSelf: 'center', paddingBottom: '0.5em' }}>
                        <div className="label" style={{ marginRight: '1em' }}>
                            Convection Risk Level
                        </div>
                        <Flex size="12em">
                            <Select
                                value={this.state.convectionRiskLevel}
                                onChange={value => this.setState({ convectionRiskLevel: value })}
                                style={{ width: '6em' }}
                                // Force render  of dropdown inside the popover content
                                // Fix popover hiding on click
                                getPopupContainer={trigger => trigger.parentNode}>
                                <Select.Option value={1}>Low</Select.Option>
                                <Select.Option value={2}>Medium</Select.Option>
                                <Select.Option value={3}>High</Select.Option>
                                <Select.Option value={4}>Critical</Select.Option>
                            </Select>
                        </Flex>
                    </Flex>
                </Flex>
                <ConditionalRender condition={AppContext.getConvectionSource() === ConvectionSource.DWD_ICONV}>
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.hideConvectionWithNoImpact}
                            onChange={value => this.setState({ hideConvectionWithNoImpact: value.target.checked })}>
                            Hide convection without TV impact
                        </Checkbox>
                    </Flex>
                </ConditionalRender>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}
